function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback, useEffect } from "react";
import { Field, FieldArray, Form as FormikForm, Formik, getIn } from "formik";
import * as Yup from "yup";
import Form from "react-bootstrap/Form";
import moment from "moment-timezone";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { default as BootstrapForm } from "react-bootstrap/Form";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import jwtDecode from "jwt-decode";
import { UserContext } from "../index";
import { useQuery, useMutation } from "@apollo/client";
import { ADD_STEP_1_MUTATION, ADD_STEP_2_MUTATION, ACCOUNT_CREATION_MUTATION, ADD_STEP_1_EDIT_MUTATION, DOWNLOAD_LINK_QUERY } from "./query";
import classNames from "classnames";
import "./OnBoarding.css";
import Profile from "../img/workfolio-blue.png";
import { HiCheckCircle } from "react-icons/hi";
var Group = BootstrapForm.Group,
  Label = BootstrapForm.Label,
  Control = BootstrapForm.Control;
import { Helmet } from "react-helmet";
var AddTeamsSchema = Yup.object().shape({
  teams: Yup.array().of(Yup.string().matches(/^[0-9a-zA-Z\s-&.(),]*$/, "We support alphanumeric and (.,-&) symbols only"))
});
var OnBoarding = function OnBoarding(props) {
  var _history$location, _history$location2, _history$location2$st, _user$organisations$;
  var history = props === null || props === void 0 ? void 0 : props.history;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _useState = useState("AccountCreation"),
    _useState2 = _slicedToArray(_useState, 2),
    pageShow = _useState2[0],
    setPageShow = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    users = _useState4[0],
    setUsers = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    organisation = _useState6[0],
    setOrganisation = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    token = _useState8[0],
    setToken = _useState8[1];
  var from = (history === null || history === void 0 ? void 0 : history.location) && (history === null || history === void 0 ? void 0 : (_history$location = history.location) === null || _history$location === void 0 ? void 0 : _history$location.state) && (history === null || history === void 0 ? void 0 : (_history$location2 = history.location) === null || _history$location2 === void 0 ? void 0 : (_history$location2$st = _history$location2.state) === null || _history$location2$st === void 0 ? void 0 : _history$location2$st.from);

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  if (user && (user === null || user === void 0 ? void 0 : (_user$organisations$ = user.organisations[0]) === null || _user$organisations$ === void 0 ? void 0 : _user$organisations$.userOnboardStatus) != "Onboard Process Incompleted") {
    return /*#__PURE__*/React.createElement("div", {
      className: "on-boarding-unauthorized-text"
    }, "You are not authorised to access this page. Pls go back to the previous page.");
  }
  React.useEffect(function () {
    setUsers(user);
    //console.log("mount");
  }, []);
  React.useEffect(function () {
    var _user$organisations$2;
    var temp = user === null || user === void 0 ? void 0 : (_user$organisations$2 = user.organisations[0]) === null || _user$organisations$2 === void 0 ? void 0 : _user$organisations$2.userOnboardContinueStep;
    var steps = temp === "" || temp === "step1" ? "OnBoardingStep1" : "OnBoardingStep2";
    setPageShow(steps);
  }, [props.location.key]);
  React.useEffect(function () {
    if (user.organisations[0].id == "eaee7240-86a3-11ed-9eb1-57cd70512d5c") {
      //naman@savior.im onboarding fixes added
      localStorage.removeItem("token");
      history.push("/login");
    }
  }, [user]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | OnBoarding | ", user === null || user === void 0 ? void 0 : user.displayName)), pageShow === "OnBoardingStep1" ? /*#__PURE__*/React.createElement(OnBoardingStep1, {
    setPageShow: setPageShow,
    users: users,
    setUsers: setUsers,
    setToken: setToken,
    user: user,
    history: history
  }) : pageShow === "OnBoardingStep2" ? /*#__PURE__*/React.createElement(OnBoardingStep2, {
    setUsers: setUsers,
    organisation: organisation,
    users: users,
    setPageShow: setPageShow,
    setToken: setToken,
    user: user,
    history: history
  }) : /*#__PURE__*/React.createElement(OnBoardingStep3, {
    history: history,
    users: users,
    organisation: organisation,
    token: token
  }));
};
var AccountSchema = Yup.object().shape({
  name: Yup.string().trim().required("Required"),
  email: Yup.string().trim().required("Required"),
  password: Yup.string().trim().required("Required")
});
var AccountCreation = function AccountCreation(props) {
  var setUsers = props.setUsers,
    setPageShow = props.setPageShow;
  var _useMutation = useMutation(ACCOUNT_CREATION_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    createUser = _useMutation2[0],
    createUserLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var variables, response, users;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // console.log("values");
            // console.log(values);
            variables = {
              authType: "email",
              username: values.name,
              email: values.email,
              password: values.password,
              accessToken: null
            };
            _context.prev = 1;
            _context.next = 4;
            return createUser({
              variables: variables,
              awaitRefetchQueries: true
            });
          case 4:
            response = _context.sent;
            if (!(!response || !response.data || response.data.createUser == null)) {
              _context.next = 9;
              break;
            }
            throw new Error("error");
          case 9:
            users = jwtDecode(response.data.createUser);
            setUsers(users);
            setPageShow("OnBoardingStep1");
          case 12:
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            console.log(_context.t0);
            if (_context.t0.message.includes("User with the email already exists")) {
              actions.setFieldError("email", "User with the email already exists");
            }
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [createUser, createUserLoading]);
  return /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: "text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "account-creation-logo-full"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: Profile,
    className: "account-root-img-responsive login-root-img-center m-b-20",
    width: "18",
    height: "18"
  }), /*#__PURE__*/React.createElement("span", {
    className: "account-creation-logo-text"
  }, "Workfolio")), /*#__PURE__*/React.createElement("h1", {
    className: "on-boarding-root-header"
  }, "Create Account")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      name: "",
      email: "",
      password: ""
    }
    // Hooks up our validationSchema to Formik
    ,
    validationSchema: AccountSchema,
    onSubmit: handleSubmit
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting,
      values = _ref2.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, {
      className: "on-boarding-root-content-form"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "name"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, "Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "name",
        type: "text",
        placeholder: "Your name"
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "email"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, "Email"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "email",
        type: "email",
        placeholder: "Your email"
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "password"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, "Password"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "password",
        type: "password",
        placeholder: "Your password"
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Button, {
      className: "on-boarding-root-content-form-account-submit-button",
      type: "submit",
      disabled: isSubmitting
    }, "Sign Up"))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "account-root-footer font-weight-bold"
  }, "Already have an account?", /*#__PURE__*/React.createElement("a", {
    href: "http://174.138.121.76:5001/login",
    className: "font-weight-bold"
  }, " ", "Login")))));
};
var OnBoardingStep3 = function OnBoardingStep3(props) {
  var _linkData$appDownload, _linkData$appDownload2, _linkData$appDownload3, _linkData$appDownload4;
  var organisation = props.organisation,
    users = props.users,
    token = props.token,
    history = props.history;
  var isWindow = typeof window !== "undefined";
  var _React$useState = React.useState({
      width: isWindow ? 1200 : window.innerWidth,
      height: isWindow ? 800 : window.innerHeight
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    windowSize = _React$useState2[0],
    setWindowSize = _React$useState2[1];
  var userCtx = React.useContext(UserContext);
  var _useQuery = useQuery(DOWNLOAD_LINK_QUERY, {}),
    linkData = _useQuery.data,
    linkError = _useQuery.error,
    linkLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  function changeWindowSize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  React.useEffect(function () {
    window.addEventListener("resize", changeWindowSize);
    return function () {
      window.removeEventListener("resize", changeWindowSize);
    };
  }, []);

  // if (typeof window.gr === "function") {
  //   // 👇️ this runs
  //   console.log("✅ gr function is defined");
  //   console.log({ users, emailId: users?.emailId });

  //   if (users && users?.emailId) {
  //     console.log({ users, emailId: users?.emailId });
  //     window.gr("track", "conversion", { email: users?.emailId });
  //   }
  // } else {
  //   console.log("⛔️ gr function is NOT defined"); // Normally this means the gr function wasn't declared here, try and look why the Tracking Script isn't running on this page
  // }

  //console.log("windowSize = 768",windowSize,window.innerWidth, " ",typeof window !== "undefined");
  //console.log("window.innerWidth > 768",window.innerWidth > 768);
  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _localStorage, _localStorage$setItem, _userCtx$setUser, script, noscript, iframe;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (users) {
              //if(window.innerWidth > 768 && isWindow){
              (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$setItem = _localStorage.setItem) === null || _localStorage$setItem === void 0 ? void 0 : _localStorage$setItem.call(_localStorage, "token", token);
              userCtx === null || userCtx === void 0 ? void 0 : (_userCtx$setUser = userCtx.setUser) === null || _userCtx$setUser === void 0 ? void 0 : _userCtx$setUser.call(userCtx, jwtDecode(token));

              // Add GTM script
              script = document.createElement("script");
              script.type = "text/javascript";
              script.async = true;
              script.innerHTML = "\n      (function (w, d, s, l, i) {\n        w[l] = w[l] || [];\n        w[l].push({ \"gtm.start\": new Date().getTime(), event: \"gtm.js\" });\n        var f = d.getElementsByTagName(s)[0],\n          j = d.createElement(s),\n          dl = l != \"dataLayer\" ? \"&l=\" + l : \"\";\n        j.async = true;\n        j.src = \"https://www.googletagmanager.com/gtm.js?id=\" + i + dl;\n        f.parentNode.insertBefore(j, f);\n      })(window, document, \"script\", \"dataLayer\", \"GTM-M3WXVD5\");\n    ";

              // Append the script to the body
              document.body.appendChild(script);

              // Add GTM noscript
              noscript = document.createElement("noscript");
              iframe = document.createElement("iframe");
              iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-M3WXVD5";
              iframe.height = "0";
              iframe.width = "0";
              iframe.style.display = "none";
              iframe.style.visibility = "hidden";
              noscript.appendChild(iframe);
              document.body.appendChild(noscript);
              history.push("/settings/manage-employees");
              // }
              // else{
              //   //localStorage?.setItem?.("token", token);

              //   // userCtx?.setUser?.(jwtDecode(token));
              //   history.push("/app-error");
              // }
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 10,
      offset: 1
    },
    className: "text-center step3-header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    className: "onboarding-step-badges"
  }, "Step 3/3")), /*#__PURE__*/React.createElement("h3", {
    className: "on-boarding-root-header"
  }, "Congratulations!!!"), /*#__PURE__*/React.createElement("label", {
    className: "on-boarding-root-header"
  }, "You have successfully configured your company in Workfolio")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 10,
      offset: 1
    },
    className: "on-boarding-next-step-admin-and-user"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-and-user"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6
    },
    className: "on-boarding-next-step-admin"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "on-boarding-next-step-admin-headers"
  }, "NEXT STEP FOR YOU"), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "1"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Invite your teammates to Workfolio")), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "2"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Configure track settings & timezone as per your need")))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6
    },
    className: "on-boarding-next-step-employee"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "on-boarding-next-step-admin-headers"
  }, "TO USE WORKFOLIO DESKTOP APP"), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "1"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Download", " ", /*#__PURE__*/React.createElement("a", {
    className: "",
    href: linkData === null || linkData === void 0 ? void 0 : (_linkData$appDownload = linkData.appDownloadLink) === null || _linkData$appDownload === void 0 ? void 0 : _linkData$appDownload.windows,
    target: "_blank",
    "data-saferedirecturl": linkData === null || linkData === void 0 ? void 0 : (_linkData$appDownload2 = linkData.appDownloadLink) === null || _linkData$appDownload2 === void 0 ? void 0 : _linkData$appDownload2.windows
  }, "Workfolio Windows App"), " ", "or", " ", /*#__PURE__*/React.createElement("a", {
    className: "",
    href: linkData === null || linkData === void 0 ? void 0 : (_linkData$appDownload3 = linkData.appDownloadLink) === null || _linkData$appDownload3 === void 0 ? void 0 : _linkData$appDownload3.mac,
    target: "_blank",
    "data-saferedirecturl": linkData === null || linkData === void 0 ? void 0 : (_linkData$appDownload4 = linkData.appDownloadLink) === null || _linkData$appDownload4 === void 0 ? void 0 : _linkData$appDownload4.mac
  }, "Workfolio Mac App"), " ", "or", " ", /*#__PURE__*/React.createElement("a", {
    className: "",
    href: "https://workfolio.tawk.help/article/workfolio-linux-application-installation-guide",
    target: "_blank",
    "data-saferedirecturl": "https://workfolio.tawk.help/article/workfolio-linux-application-installation-guide"
  }, "Workfolio Linux App"))), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "2"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Install the Workfolio desktop app in your system")), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "3"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Login with your credential in workfolio desktop app")), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "4"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Start to use it")))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6
    },
    className: "on-boarding-next-step-employee"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "on-boarding-next-step-admin-headers"
  }, "NEXT STEP FOR EMPLOYEES"), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "1"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Create an account using the invite mail or invite link")), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "2"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Download and install the workfolio desktop app")), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "3"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Login with the credential in workfolio desktop app")), /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-next-step-admin-datas"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label-count"
  }, "4"), /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-next-step-admin-content-label"
  }, "Start using it")))), /*#__PURE__*/React.createElement(Row, {
    className: "on-boarding-root-content-form-invite-user-row"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "on-boarding-root-content-form-save-button",
    type: "submit",
    onClick: onSubmit
  }, "Take me to invite members")))));
};
var errorMessage = function errorMessage(errors, touched, name) {
  var error = getIn(errors, name);
  var touch = getIn(touched, name);
  if (touch && error) {
    return /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, error);
  }
  return null;
};
var OnBoardingStep2 = function OnBoardingStep2(props) {
  var organisation = props.organisation,
    users = props.users,
    setPageShow = props.setPageShow,
    setToken = props.setToken,
    user = props.user,
    history = props.history;
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    onboardError = _React$useState4[0],
    setOnboardError = _React$useState4[1];
  var _useMutation3 = useMutation(ADD_STEP_2_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    onboardingTeamSettings = _useMutation4[0],
    onboardingTeamSettingsLoading = _useMutation4[1].loading;
  var onSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          setPageShow("OnBoardingStep1");
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [onboardingTeamSettings, onboardingTeamSettingsLoading]);
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values, _ref5) {
      var setFieldError, variables, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setFieldError = _ref5.setFieldError;
            // console.log(users);
            // console.log(organisation);
            variables = {
              organisationId: users.organisations[0].id,
              organisationName: users.organisations[0].name,
              userId: users.userId,
              emailId: users.emailId,
              displayName: users.displayName,
              teamName: values.teams,
              profileUrl: null,
              ruleName: "Less Working Hours",
              ruleDays: 4,
              rules: [{
                ruleType: "Work hours",
                ruleTimeSec: "25200",
                ruleTimeCondition: "less than"
              }]
            };
            _context4.prev = 2;
            _context4.next = 5;
            return onboardingTeamSettings({
              variables: variables,
              awaitRefetchQueries: true
            });
          case 5:
            response = _context4.sent;
            if (!(!response || !response.data || response.data.onboardingTeamSettings == null)) {
              _context4.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            setToken(response.data.onboardingTeamSettings);
            setPageShow("OnBoardingStep3");
          case 12:
            _context4.next = 19;
            break;
          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](2);
            setFieldError("formError", _context4.t0.message);
            setOnboardError(true);
            console.log(_context4.t0);
          case 19:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 14]]);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }(), [onboardingTeamSettings, onboardingTeamSettingsLoading]);
  return /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 8,
      offset: 2
    },
    className: "text-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    className: "onboarding-step-badges"
  }, "Step 2/3")), /*#__PURE__*/React.createElement("h3", {
    className: "on-boarding-root-header-team"
  }, "Let's set up your teams"), /*#__PURE__*/React.createElement("label", {
    className: "on-boarding-root-header on-boarding-root-header-color"
  }, "You can add or delete teams later")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 8,
      offset: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      teams: ["Design Team", "HR Team"]
    }
    // Hooks up our validationSchema to Formik
    ,
    validationSchema: AddTeamsSchema
    //onSubmit={onSubmit}
    ,
    onSubmit: handleSubmit
  }, function (formikProps) {
    var values = formikProps.values,
      errors = formikProps.errors,
      touched = formikProps.touched,
      isSubmitting = formikProps.isSubmitting;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(FieldArray, {
      name: "teams",
      render: function render(teamArrayHelpers) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, values.teams.map(function (team, teamIndex) {
          var teamError = errorMessage(errors, touched, "teams[".concat(teamIndex, "]"));
          return /*#__PURE__*/React.createElement(Form.Row, {
            className: "employee-row justify-content-center justify-content-md-center"
          }, /*#__PURE__*/React.createElement(Col, {
            lg: 6,
            xs: 7,
            sm: 7,
            md: 6,
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Form.Group, null, teamError, /*#__PURE__*/React.createElement(Field, {
            as: Form.Control,
            name: "teams[".concat(teamIndex, "]"),
            type: "text",
            value: team,
            required: true,
            placeholder: "Enter team name",
            isInvalid: teamError != null
          }))), /*#__PURE__*/React.createElement(Col, {
            lg: {
              span: 3
            },
            xs: {
              span: 5
            },
            sm: {
              span: 5
            },
            md: {
              span: 3
            },
            className: ""
          }, values.teams.length !== 1 ? /*#__PURE__*/React.createElement(Button, {
            variant: "outline-danger",
            className: "onboarding-remove-team",
            size: "md",
            onClick: function onClick() {
              return teamArrayHelpers.remove(teamIndex);
            }
          }, "Remove team") : null));
        }), user.organisations[0].planType === "free" && values.teams.length < 2 || user.organisations[0].planType === "startup" && values.teams.length < 2 || user.organisations[0].planType !== "free" && user.organisations[0].planType !== "startup" ? /*#__PURE__*/React.createElement(Form.Row, {
          className: "employee-row justify-content-md-center"
        }, /*#__PURE__*/React.createElement(Col, {
          xs: 6,
          sm: 6,
          md: 6,
          className: "mb-2"
        }, /*#__PURE__*/React.createElement(Button, {
          className: "onboard-add-new-team",
          variant: "link",
          onClick: function onClick() {
            return teamArrayHelpers.push("");
          }
        }, "+ Add another team")), /*#__PURE__*/React.createElement(Col, {
          xs: {
            span: 3
          },
          sm: {
            span: 3
          },
          md: {
            span: 3
          },
          className: ""
        })) : null);
      }
    }), user.organisations[0].planType === "free" || user.organisations[0].planType === "startup" ? /*#__PURE__*/React.createElement(Form.Row, {
      className: "employee-row justify-content-md-center onboarding2-free-plan-team-limit-label"
    }, /*#__PURE__*/React.createElement(Col, {
      lg: 9,
      xs: 11,
      sm: 11,
      md: 9,
      className: "mb-2"
    }, "In ", user.organisations[0].planType, " plan, maximum team limit is 2."), " ") : null, /*#__PURE__*/React.createElement(Form.Row, {
      className: "employee-row onboarding-footer-button justify-content-md-center"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      sm: 6,
      md: 6,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "on-boarding-root-content-form-skip-button",
      variant: "secondary"
      //disabled={isSubmitting}
      ,
      onClick: onSubmit
    }, "Previous Step")), /*#__PURE__*/React.createElement(Col, {
      lg: {
        span: 3
      },
      xs: {
        span: 6
      },
      sm: {
        span: 6
      },
      md: {
        span: 3
      },
      className: ""
    }, /*#__PURE__*/React.createElement(Button, {
      className: "on-boarding-root-content-form-save-button-team",
      type: "submit",
      disabled: isSubmitting
    }, "Save & Next"))), onboardError ? /*#__PURE__*/React.createElement(Form.Row, {
      className: "onboarding-footer-div justify-content-md-center"
    }, "Teams have already been created. Click here to", /*#__PURE__*/React.createElement("span", {
      className: "onboarding-footer-div-login",
      onClick: function onClick() {
        localStorage.removeItem("token");
        history.push("/login");
      }
    }, " ", "login"), ".") : null);
  }))));
};
var OnBoardingStep1Schema = Yup.object().shape({
  companyName: Yup.string().trim().required("Required").matches(/^[0-9a-zA-Z\s-&.(),]*$/, "We support alphanumeric and (.,-&) symbols only")
});
var OnBoardingStep1 = function OnBoardingStep1(props) {
  var _users$organisations$5;
  var setUsers = props.setUsers,
    users = props.users,
    setPageShow = props.setPageShow,
    setToken = props.setToken,
    user = props.user,
    history = props.history;
  var userCtx = React.useContext(UserContext);
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    onboardStep1Error = _React$useState6[0],
    setOnboardStep1Error = _React$useState6[1];
  var _React$useState7 = React.useState(["Screenshots", "Apps & Website Tracking", "Timesheet"]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    activeWorkingDays = _React$useState8[0],
    setWorkingDays = _React$useState8[1];

  //  console.log("users");
  //  console.log(users);

  var selectWorkingDays = function selectWorkingDays(workingDays) {
    setWorkingDays(function (prev) {
      if (prev.length === 1 && prev.includes(workingDays)) return prev;
      return prev.includes(workingDays) ? prev.filter(function (a) {
        return a !== workingDays;
      }) : [].concat(_toConsumableArray(prev), [workingDays]);
    });
  };
  // const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  var tz = moment.tz.guess();
  if (!tz) {
    tz = "Asia/Kolkata";
  }
  var _useMutation5 = useMutation(ADD_STEP_1_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    onboardingOrganisationSettings = _useMutation6[0],
    onboardingOrganisationSettingsLoading = _useMutation6[1].loading;
  var _useMutation7 = useMutation(ADD_STEP_1_EDIT_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    onboardingOrganisationSettingsEdit = _useMutation8[0],
    onboardingOrganisationSettingsEditLoading = _useMutation8[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(values) {
      var _users$organisations$, _users$organisations$2, _users$organisations$3;
      var variables, editVariables, _users$organisations$4, responses, organisations, response, _localStorage2, _localStorage2$setIte, _userCtx$setUser2, organisation;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            // console.log(users);
            variables = {
              organisationName: values.companyName,
              workingDays: "Monday,Tuesday,Wednesday,Friday,Thursday",
              screenCapture: activeWorkingDays.includes("Screenshots") ? "true" : "false",
              trackAppsAndWebsites: activeWorkingDays.includes("Apps & Website Tracking") ? "true" : "false",
              allowMemberToAccessTimesheet: user.organisations[0].planType === "free" ? "true" : activeWorkingDays.includes("Timesheet") ? "true" : "false",
              screenCaptureInterval: user.organisations[0].planType === "free" ? "10" : "1",
              // idleMinutes:"5",
              idleMinutesThreshold: "1",
              workingHoursPerDay: "480",
              productiveHours: "420",
              organisationTimezone: tz === "Asia/Calcutta" || tz === "Asia/Culcutta" ? "Asia/Kolkata" : tz,
              userId: users.userId,
              emailId: users.emailId,
              displayName: users.displayName,
              planType: (_users$organisations$ = users.organisations[0].planType) !== null && _users$organisations$ !== void 0 ? _users$organisations$ : "free",
              adminCheck: "true"
            };
            editVariables = {
              organisationName: values.companyName,
              organisationId: users !== null && users !== void 0 && (_users$organisations$2 = users.organisations[0]) !== null && _users$organisations$2 !== void 0 && _users$organisations$2.id ? users === null || users === void 0 ? void 0 : (_users$organisations$3 = users.organisations[0]) === null || _users$organisations$3 === void 0 ? void 0 : _users$organisations$3.id : "",
              workingDays: "Monday,Tuesday,Wednesday,Friday,Thursday",
              screenCapture: activeWorkingDays.includes("Screenshots") ? "true" : "false",
              trackAppsAndWebsites: activeWorkingDays.includes("Apps & Website Tracking") ? "true" : "false",
              allowMemberToAccessTimesheet: user.organisations[0].planType === "free" ? "false" : activeWorkingDays.includes("Timesheet") ? "true" : "false",
              screenCaptureInterval: user.organisations[0].planType === "free" ? "10" : "1",
              // idleMinutes:"5",
              idleMinutesThreshold: "1",
              workingHoursPerDay: "480",
              productiveHours: "420",
              organisationTimezone: tz === "Asia/Calcutta" || tz === "Asia/Culcutta" ? "Asia/Kolkata" : tz,
              userId: users.userId,
              emailId: users.emailId,
              displayName: users.displayName,
              adminCheck: "true"
            };
            _context5.prev = 2;
            if (!(users !== null && users !== void 0 && (_users$organisations$4 = users.organisations[0]) !== null && _users$organisations$4 !== void 0 && _users$organisations$4.name)) {
              _context5.next = 16;
              break;
            }
            _context5.next = 6;
            return onboardingOrganisationSettingsEdit({
              variables: editVariables,
              awaitRefetchQueries: true
            });
          case 6:
            responses = _context5.sent;
            if (!(!responses || !responses.data || responses.data.onboardingOrganisationSettingsEdit == null)) {
              _context5.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            organisations = jwtDecode(responses.data.onboardingOrganisationSettingsEdit);
            setUsers(organisations);
            setPageShow("OnBoardingStep2");
          case 14:
            _context5.next = 28;
            break;
          case 16:
            _context5.next = 18;
            return onboardingOrganisationSettings({
              variables: variables,
              awaitRefetchQueries: true
            });
          case 18:
            response = _context5.sent;
            if (!(!response || !response.data || response.data.onboardingOrganisationSettings == null)) {
              _context5.next = 23;
              break;
            }
            throw new Error("error");
          case 23:
            organisation = jwtDecode(response.data.onboardingOrganisationSettings);
            setUsers(organisation);
            (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : (_localStorage2$setIte = _localStorage2.setItem) === null || _localStorage2$setIte === void 0 ? void 0 : _localStorage2$setIte.call(_localStorage2, "token", response.data.onboardingOrganisationSettings);
            userCtx === null || userCtx === void 0 ? void 0 : (_userCtx$setUser2 = userCtx.setUser) === null || _userCtx$setUser2 === void 0 ? void 0 : _userCtx$setUser2.call(userCtx, jwtDecode(response.data.onboardingOrganisationSettings));
            setPageShow("OnBoardingStep2");
          case 28:
            _context5.next = 34;
            break;
          case 30:
            _context5.prev = 30;
            _context5.t0 = _context5["catch"](2);
            console.log(_context5.t0);
            setOnboardStep1Error(true);
          case 34:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 30]]);
    }));
    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }(), [onboardingOrganisationSettings, onboardingOrganisationSettingsLoading, activeWorkingDays]);
  // console.log("activeWorkingDays");
  // console.log(activeWorkingDays);
  return /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-md-center"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 7
    },
    className: "justify-content-md-center text-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    className: "onboarding-step-badges"
  }, "Step 1/3")), /*#__PURE__*/React.createElement("h3", {
    className: "on-boarding-root-header"
  }, "Welcome to Workfolio, let's get you set up in 3 easy steps.")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 7
    },
    className: "justify-content-md-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      companyName: users !== null && users !== void 0 && (_users$organisations$5 = users.organisations[0]) !== null && _users$organisations$5 !== void 0 && _users$organisations$5.name ? users.organisations[0].name : ""
    }
    // Hooks up our validationSchema to Formik
    ,
    validationSchema: OnBoardingStep1Schema,
    onSubmit: handleSubmit
  }, function (_ref8) {
    var isSubmitting = _ref8.isSubmitting,
      values = _ref8.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, {
      className: "on-boarding-root-content-form"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "companyName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "onboard-company-name-lable"
      }, "Add your company name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        className: "onboarding-company-name-textbox",
        name: "companyName",
        type: "text",
        placeholder: "Your company name"
      }, field, {
        autoFocus: true
      })));
    })), user.organisations[0].planType == undefined || user.organisations[0].planType === "free" || user.organisations[0].planType === "startup" ? null : null
    // (
    //   <>
    //     <Col xs={12} md={12}>
    //       <h5 className="fs-18 m-b-16 on-boarding-root-content-form-title">
    //         Choose the feature you are interested in...
    //       </h5>
    //     </Col>
    //     <Col xs={12} md={12}>
    //       <p className="fs-18 m-b-16 on-boarding-root-content-form-title-muted">
    //         Don't worry, you will be able to change these later if you change your mind
    //       </p>
    //     </Col>
    //     <Col xs={12} md={12}>
    //       <div className="on-boarding-root-content-form-settings">
    //         <div
    //           className={classNames("on-boarding-root-content-form-settings-box", {
    //             "on-boarding-settings-worked-days-selected": activeWorkingDays.includes("Screenshots"),
    //           })}
    //           onClick={() => selectWorkingDays("Screenshots")}
    //         >
    //           <HiCheckCircle
    //             className={classNames("account-root-tick-icon-screen", {
    //               "account-root-tick-icon-screen-none": activeWorkingDays.includes("Screenshots"),
    //             })}
    //           />
    //           <div className="on-boarding-root-content-form-settings-box-text">Screenshots</div>
    //         </div>
    //         <div
    //           className={classNames("on-boarding-root-content-form-settings-box", {
    //             "on-boarding-settings-worked-days-selected":
    //               activeWorkingDays.includes("Apps & Website Tracking"),
    //           })}
    //           onClick={() => selectWorkingDays("Apps & Website Tracking")}
    //         >
    //           <HiCheckCircle
    //             className={classNames("account-root-tick-icon-app", {
    //               "account-root-tick-icon-screen-none":
    //                 activeWorkingDays.includes("Apps & Website Tracking"),
    //             })}
    //           />
    //           <div className="on-boarding-root-content-form-settings-box-text">
    //             Apps & Website Tracking
    //           </div>
    //         </div>
    //         <div
    //           className={classNames("on-boarding-root-content-form-settings-box", {
    //             "on-boarding-settings-worked-days-selected": activeWorkingDays.includes("Timesheet"),
    //           })}
    //           onClick={() => selectWorkingDays("Timesheet")}
    //         >
    //           <HiCheckCircle
    //             className={classNames("account-root-tick-icon", {
    //               "account-root-tick-icon-screen-none": activeWorkingDays.includes("Timesheet"),
    //             })}
    //           />
    //           <div className="on-boarding-root-content-form-settings-box-text">Timesheet</div>
    //         </div>
    //       </div>
    //     </Col>
    //   </>
    // )
    , /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      className: "on-boarding-root-content-form-submit-div"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "on-boarding-root-content-form-submit-button",
      type: "submit",
      disabled: isSubmitting
    }, "Save & Next"))), onboardStep1Error ? /*#__PURE__*/React.createElement(Form.Row, {
      className: "onboarding-footer-div justify-content-md-center"
    }, "The organisation has already been created. Click here to", /*#__PURE__*/React.createElement("span", {
      className: "onboarding-footer-div-login",
      onClick: function onClick() {
        localStorage.removeItem("token");
        history.push("/login");
      }
    }, " ", "login"), ".") : null);
  })))));
};
export default /*#__PURE__*/React.memo(OnBoarding);